module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row1_googleQRcode.255a02d6.png";